<template>
  <div class="mw-open-form">
    <div class="mw-from-top-con"  id="mw-form"></div>
    <div class="mw-form-bot-btns">
      <el-button type="primary" @click="saveFormData()">保存</el-button>
    </div>
  </div>
</template>

<script>
  import dataApi from '@/common/api/data';
  import appApi from '@/common/api/app';
  import configApi from '@/common/api/config';

  let newForm;

  export default
  {
    name: 'MwGeneralForm',
    data(){
      return {
        entityId:'',
        formName:'',
        buttons:[]
      }
    },
    props: {
      formId:String,
      appId: String
    },
    mounted() {
      this.renderForm(this.formId);
    },
    methods: {
      resetForm(){
        this.formName='';
        this.buttons=[];
        $("#mw-form").empty();
      },
      renderForm(formId){
        let me=this;
        if(formId){
          configApi.formConfig(this.businessId,formId,this.appId).then((data) => {
            let res=data.result;
            me.formName=res.name;
            me.entityId=res.entityId;
            $WR.ready(function (manager) {
              manager.create({xtype: 'Form', $dd:res.content}, function (form) {
                newForm = form;
                newForm.render($("#mw-form"));
                newForm.setValue(res.formData);
              })
            })
          });
        }else{
          me.resetForm();
        }
      },
      formData(){
        return newForm&&newForm.getValue();
      },
      saveFormData(){
        var me=this;
        var params={
          formId:this.formId,
          appId:this.appId,
          entityId:this.entityId,
          values: me.formData(),
        };
        dataApi.saveFormData(params).then((data) => {
          me.$emit("formActionComplete");
        });
      }
    },
    watch: {
      formId(newVal) {
        this.formId=newVal;
        this.renderForm(newVal);
      }
    }
  }
</script>

<style>
  .x-form-view .x-form-head{
    position: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/general-form/src/main.vue